import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { ToastBehaviorService } from '../behavior/toast-behavior.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(  ) { }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ProgressEvent) {
      console.error('Ocorrência do erro:', error.message);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `Body: ${error.error}`);
    }
    return throwError(error);
  };
}
